import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
} from '@tanstack/react-query';
import Card from 'components/card';
import Button from 'components/button';
import SimpleTable from 'components/simpleTable';
import Header from 'components/text/header';
import UseApi from 'hooks/useApi';
import { HiArrowLeft } from 'react-icons/hi';
import Loader from 'components/loader';

const queryClient = new QueryClient();

const RequestDetails = () => {
  const { id } = useParams();
  const { getApi, postApi } = UseApi();
  const navigate = useNavigate();

  const fetchData = async (id: string) => {
    const response = await getApi(`withdrawalRequests/${id}`);
    return response.data;
  };

  const { data, isLoading, error } = useQuery({
    queryKey: ['data', id],
    queryFn: () => fetchData(id),
  });
  

  if (isLoading) return <Loader />;
  if (error) return <Header>An error has occurred: {error.message}</Header>;

  const approve = async () => {
    await postApi(`withdrawalRequests/${id}/accept`, {});
    navigate('/admin/withdrawal-request');
  };
  const reject = async () => {
    await postApi(`withdrawalRequests/${id}/reject`, {});
    navigate('/admin/withdrawal-request');
  };
  return (
    <div className="flex flex-col gap-3">
      <Link key={1} to={'/admin/withdrawal-request'}>
        <Button variant="gray" extraClasses="flex items-center gap-2 ">
          <HiArrowLeft />
          Back
        </Button>
      </Link>
      <Card extra="gap-2 p-4">
        <SimpleTable
          header="Request Details"
          data={[
            {
              key: 'User',
              value: (
                <Link target="#" to={`/admin/user/${data?.user?._id}`}>
                  {' '}
                  {data.user?.username || data.user?.email}
                </Link>
              ),
            },
            { key: 'Amount', value: 'Rs ' + data.amount },
            { key: 'Bank Name', value: data?.userWallet?.bankAccounts?.[0]?.bank },
            { key: 'Account Number', value: data?.userWallet?.bankAccounts?.[0]?.iban },
            { key: 'Account Title', value: data?.userWallet?.bankAccounts?.[0]?.title },
          ]}
        />
        <Button extraClasses="m-auto" variant="success" onClick={approve}>
          Approve
        </Button>
        <Button extraClasses="m-auto" variant="error" onClick={reject}>
          Reject
        </Button>
      </Card>
    </div>
  );
};

const WithdrawalRequestDetails = (props: {}) => {
  return (
    <QueryClientProvider client={queryClient}>
      <RequestDetails />
    </QueryClientProvider>
  );
};

export default WithdrawalRequestDetails;
